import React from 'react';
import Grid from '@material-ui/core/Grid';
import AssignmentEditor from './AssignmentEditor';
import {
  AssignmentData,
  AssignmentEditStatus,
  AssignmentEmptyData,
  AssignmentIndependentQuestion,
  AssignmentPassage,
  AssignmentQuestionFormat,
  AssignmentQuestionType
} from '../../state/assignment-edit.types';

interface AssignmentEditorListProps {
  data: (
    | AssignmentIndependentQuestion
    | AssignmentPassage
    | AssignmentEmptyData
  )[];
  handleUpdateQuestionType(id: string, type: AssignmentQuestionType): void;
  handleQuestionText(
    id: string,
    data: Partial<AssignmentData>,
    rootId?: string
  ): void;
  handleQuestionFormat(
    id: string,
    format: AssignmentQuestionFormat,
    rootId?: string
  ): void;
  handleAnswerUpdate(
    questionId: string,
    answerId: string,
    data: object,
    type?: AssignmentQuestionType,
    rootId?: string
  ): void;
  handleDeleteAnswer(
    id: string,
    answerId: string,
    type?: AssignmentQuestionType,
    rootId?: string
  ): void;
  handleAddAnswer(id: string, rootId?: string): void;
  handleAddQuestion(rootId?: string): void;
  handleDeleteQuestion(id: string, rootId?: string): void;
  status: AssignmentEditStatus;
}

const AssignmentEditorList: React.FC = props => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          {props.children}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AssignmentEditorList;
